Ext.define('SA.view.sidebar.data.DataSearchResults', {
    alias: 'widget.data-search-results',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-data-search-results',
    disableHierarchy: false,
    enableClickableLeafPaths: true,

    statics: {
        getDisplayName({name, shortName}) {
            return shortName || name;
        }
    },

    initComponent() {
        this.callParent();

        this.currentGroup = null;
        this.pathToCurrentLevel = [this];
        this.selectedAttributes = [];
        this.resultAttributeIds = [];
    },

    addResults(results) {
        this.resultAttributeIds.push(...results.filter(({result}) => result).map(({result}) => result.attribute));

        Ext.suspendLayouts();

        for (let {result, placeholder} of results) {
            let {dataset_series: dataset, group, indent = 0} = result || placeholder;

            if (group !== this.currentGroup) {
                this.pathToCurrentLevel = this.pathToCurrentLevel.slice(0, 1);

                SA.Array.getLast(this.pathToCurrentLevel).add({
                    xtype: 'data-search-results-header',
                    dataset,
                    enableClickableLeafPaths: this.enableClickableLeafPaths,
                    listeners: {'click:path': (path, dataset) => this.fireEvent('click:path', path, dataset)},
                    path: group
                });

                this.currentGroup = group;
            }

            while (!this.disableHierarchy && this.pathToCurrentLevel.length <= indent) {
                this.pathToCurrentLevel.push(SA.Array.getLast(this.pathToCurrentLevel).add({
                    xtype: 'simple-container',
                    cls: 'sa-data-search-results-level'
                }));
            }

            this.pathToCurrentLevel = this.pathToCurrentLevel.slice(0, indent + 1);

            if (result) {
                SA.data.AttributesCache.add(Ext.clone(result));

                SA.Array.getLast(this.pathToCurrentLevel).add({
                    xtype: 'data-search-results-attribute',
                    attribute: result,
                    listeners: {select: attribute => this.fireEvent('select', this, attribute)},
                    selected: this.selectedAttributes.includes(result.attribute)
                });
            }
            else if (placeholder) {
                SA.Array.getLast(this.pathToCurrentLevel).add({
                    xtype: 'data-search-results-placeholder',
                    placeholder
                });
            }
        }

        Ext.resumeLayouts(true);
    },

    clear() {
        this.currentGroup = null;
        this.pathToCurrentLevel = this.pathToCurrentLevel.slice(0, 1);
        this.resultAttributeIds.length = 0;

        this.removeAll();

        SA.data.AttributesCache.purgeUnreferenced();
    },

    getAttributeIds() {
        return this.resultAttributeIds;
    },

    onDestroy() {
        SA.data.AttributesCache.purgeUnreferenced();

        this.callParent();
    },

    scrollToFirstNonPlaceholderResult() {
        this.down('data-search-results-attribute')?.getEl().dom.scrollIntoView();
    },

    scrollToTop() {
        this.getEl().dom.scrollTop = 0;
    },

    setResults(results) {
        this.clear();

        this.addResults(results);
    },

    setSelected(selectedAttributes) {
        var isSelected = result => selectedAttributes.includes(result.getAttribute());

        this.selectedAttributes = selectedAttributes;

        this.query('data-search-results-attribute').forEach(result => result.setSelected(isSelected(result)));
    }
});